import React, { Fragment } from 'react'
import styles from './AccountMergeModal.scss'
import { errorMessage } from 'lib/styleguide/base.scss'
import { CircleSpinner } from 'common/spinners'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import { ProfileImg } from 'common/ProfileImg'
import fetchJSON from 'lib/fetchJSON'
import { j } from 'lib/textUtils'

export const ACCOUNT_MERGE_MODAL = 'ACCOUNT_MERGE_MODAL'

export class AccountMergeModal extends React.PureComponent {
  state ={
    userId: null,
    preview: false,
    success: false,
    error: null
  }

  onUserIdChanged = (e) => {
    this.setState({ userId: e.target.value, preview: false, error: false })
  }

  preview = (e) => {
    e.preventDefault()
    const { fromUser } = this.props
    const { userId } = this.state

    if (!userId) {
      this.setState({ error: 'need a userId, pretty please' })
    }

    if (parseInt(userId, 10) === fromUser.id) {
      this.setState({ error: 'tryna be clever, are ya?' })
    }

    this.setState({ preview: true })
  }

  proceed = (e) => {
    e.preventDefault()
    const { fromUser, onRequestClose } = this.props
    const { userId } = this.state

    fetchJSON(`/users/${fromUser.id}/merge_into_other`, { to_id: userId }, { method: 'POST' })
      .then(_ => {
        this.setState({ success: true, preview: false })
        setTimeout(() => onRequestClose(), 3500)
      })
      .catch(e => {
        const err = e.errors[0]
        this.setState({ error: `${err.error_message}. this is what the server said: ${err.error_info}` })
      })
  }

  render () {
    const { fromUser, onRequestClose } = this.props
    const { userId, preview, success, error } = this.state

    return (
      <ModalOverlay
        title={'Account Merge'}
        maxWidth='600px'
        onCancel={onRequestClose}
        onRequestClose={onRequestClose}>
        <div>
          {success
            ? <div className={styles.accounts}>
              :tada:
              <iframe src='https://giphy.com/embed/D0WOL0ogZIoG4' width='480' height='480' frameBorder='0' allowFullScreen className={styles.arrows} />
              <CTA onClick={() => onRequestClose()}>😎</CTA>
            </div>
            : <Fragment>
              <form onSubmit={e => this.preview(e)}>
                <label>Enter the ID of the user you want to merge into</label>
                <input className={error ? errorMessage : undefined} type='number' defaultValue={userId} onChange={(e) => this.onUserIdChanged(e)} />
              </form>

              {error && <div className={errorMessage}>{error}</div>}

              <CTA secondary onClick={e => this.preview(e)} >Preview</CTA>

              {preview && <div className={styles.accounts}>
                <span>Account to merge: </span><User userId={fromUser.id} />
                <div className={styles.arrows}><iframe src='https://giphy.com/embed/b73wUq1jFLBTy' width='480' height='242' frameBorder='0' allowFullScreen /></div>
                <span>Account to keep: </span> <User userId={userId} />
                <CTA onClick={e => this.proceed(e)}>Proceed</CTA>
              </div>}
            </Fragment>}
        </div>
      </ModalOverlay>
    )
  }
}

class User extends React.PureComponent {
  state = {
    highlightedPhotoId: null,
    loaded: false
  }

  componentDidMount () {
    fetchJSON(`/users/${this.props.userId}.json`)
      .then(r => {
        const { name, highlighted_photo_id: highlightedPhotoId, locality, administrative_area: administrativeArea } = r
        this.setState({ name, highlightedPhotoId, locality, administrativeArea, loaded: true })
      })
  }

  render () {
    const { name, highlightedPhotoId, locality, administrativeArea, loaded } = this.state
    const { userId } = this.props

    return (
      <div className={styles.preview}>
        {!loaded && <CircleSpinner size={20} />}
        {loaded && <Fragment>
          <div className={styles.profileImg}>
            <ProfileImg large userId={userId} highlightedPhotoId={highlightedPhotoId} />
          </div>
          <div className={styles.UserContent}>
            <div className={styles.username}>{name}</div>
            <div className={styles.location}>{j([locality, administrativeArea])}</div>
          </div>
        </Fragment>}
      </div>
    )
  }
}
